import React from 'react'

const PremiumSuccess = () => {
  return (
    <>
        <div className=" ">
            <h1>Success</h1>
            <div className="text-center">
                Thank you for signing up for Yalango Premium! You are now ready to start using all the available premium features.
            </div>
            <div className="text-center mt-4">
                <p className="text-sm text-gray-600 dark:text-gray-400 italic">
                    Note: It may take up to a few days before all your existing cards have Text-To-Speech capabilities.
                </p>
            </div>
        </div>
    </>
  )
}

export default PremiumSuccess;